import React from 'react';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import {
  RequestTaxFormDownload,
  FetchTaxFormDownload,
} from '../../../schemas/rql';
import { ITaxForm, MutationProps } from '../tax_profile_helpers';
import MultipleTaxForms from './multiple_tax_forms';
import { connect } from '@reverbdotcom/commons/src/connect';

interface ExternalProps {
  taxForm: ITaxForm;
  taxForms: ITaxForm[];
  taxFormDownload: FetchTaxFormDownload._TaxFormDownload;
  lastRequestedAt: string;
}


type Props = ExternalProps & MutationProps;

export function TaxForms({ requestTaxFormDownload, fetchTaxFormDownload, taxForms }: Props) {
  return <MultipleTaxForms
    taxForms={taxForms}
    requestTaxFormDownload={requestTaxFormDownload}
    fetchTaxFormDownload={fetchTaxFormDownload}
  />;
}

const REQUEST_TAX_FORM_DOWNLOAD = gql`
  mutation RequestTaxFormDownload(
    $input: Input_core_apimessages_RequestTaxFormDownloadRequest
  ) {
    requestTaxFormDownload(input: $input) {
      taxFormDownload {
        id
        status
      }
      error
    }
  }
`;

const FETCH_TAX_FORM_DOWNLOAD = gql`
  mutation FetchTaxFormDownload(
    $input: Input_core_apimessages_TaxFormDownloadRequest
  ) {
    taxFormDownload(input: $input) {
      taxFormDownload {
        id
        status
        url
      }
    }
  }
`;

const withRequestTaxFormDownload = withGraphql<ExternalProps, RequestTaxFormDownload.Mutation, RequestTaxFormDownload.Variables>(
  REQUEST_TAX_FORM_DOWNLOAD, {
    name: 'requestTaxFormDownload',
    options: {
      errorPolicy: 'all',
    },
  });

const withTaxFormDownload = withGraphql<ExternalProps, FetchTaxFormDownload.Mutation, FetchTaxFormDownload.Variables>(FETCH_TAX_FORM_DOWNLOAD, {
  name: 'fetchTaxFormDownload',
  options: {
    errorPolicy: 'all',
  },
});

export default connect<ExternalProps>([withRequestTaxFormDownload, withTaxFormDownload])(TaxForms);
